/* eslint-disable max-len */
import 'react';

const ErrorNewSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    const id = `ErrorNewSvg${Date.now()}`;
    return (<svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <mask id={id} style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48">
            <rect width="48" height="48" fill="black" />
        </mask>
        <g mask={`url(#${id})`}>
            <path d="M18.8039 10C21.1133 6 26.8868 6 29.1962 10L41.3205 31C43.6299 35 40.7432 40 36.1244 40H11.8756C7.25685 40 4.3701 35 6.6795 31L18.8039 10Z" fill="#FF7E73" />
            <path d="M24 27.25V16" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M24 34C24.8284 34 25.5 33.3284 25.5 32.5C25.5 31.6716 24.8284 31 24 31C23.1716 31 22.5 31.6716 22.5 32.5C22.5 33.3284 23.1716 34 24 34Z" fill="white" />
        </g>
    </svg>);
};

export default ErrorNewSvg;
